import styled from 'styled-components';

export const Info = styled.div`
  margin-top: 10px;
`;